import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed, PropType} from "vue";
import {TableTagOptions, VATableRecord} from "../extends/typing";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableTag',
  props: {
  value: {
    type: String,
    required: true
  },
  options: {
    type: Object as PropType<TableTagOptions>,
    default: () =>{
      return {}
    }
  },
  record: {
    type: Object as PropType<VATableRecord>,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const props = __props

// tag的label值
const label = computed(()=>{
  if(!props.options)return props.value
  return props.options.labels?props.options.labels[props.value]:props.value
})

// tag的颜色，根据值不同可以改变
const color = computed(()=>{
  if(!props.options)return ""
  if(props.options.color)return props.options.color
  return props.options.colors?props.options.colors[props.value]:""
})


return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!

  return (_openBlock(), _createBlock(_component_a_tag, { color: color.value }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(label.value), 1)
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})